import { render, staticRenderFns } from "./WorkflowKanbanModal.vue?vue&type=template&id=300e82fa&"
import script from "./WorkflowKanbanModal.vue?vue&type=script&lang=js&"
export * from "./WorkflowKanbanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports